import { apiURL } from "config/constants";
import { useContextController } from "context";
import { useEffect } from "react";
import { parseIncidentDocs, parseIncidentDocsBc, setIncidentDocsBcState, setIncidentDocsState } from "./feature";

/** Loads the session feature flag. Does not call /api/v1/incidents. */
export default function FeatureFlags() {
  const [{ userData }] = useContextController();

  useEffect(() => {
    if (!userData) {
      setIncidentDocsState("off");
      setIncidentDocsBcState("off");
      return;
    }
    let cancelled = false;
    setIncidentDocsState("unknown");
    setIncidentDocsBcState("unknown");
    fetch(`${apiURL}/features`, { credentials: "include", headers: { Accept: "application/json" } })
      .then((response) => response.json())
      .then((json) => {
        if (cancelled) return;
        setIncidentDocsState(parseIncidentDocs(json) ? "on" : "off");
        setIncidentDocsBcState(parseIncidentDocsBc(json) ? "on" : "off");
      })
      .catch(() => {
        if (cancelled) return;
        setIncidentDocsState("off");
        setIncidentDocsBcState("off");
      });
    return () => {
      cancelled = true;
    };
  }, [userData]);

  return null;
}
